import _map from 'lodash/map';
import _find from 'lodash/find';

export const mapItemIds = (choices) => _map(
  choices,
  ({ metaDataItems }) => _find(
    metaDataItems,
    // eslint-disable-next-line consistent-return
    (item) => {
      if (item.name === 'Sku') {
        return item.value;
      }
    }
  )?.value
);
